import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";

export type ChatDocumentTab = "report" | "notes" | "chat" | "summary";

const DEFAULT_TAB_ORDER: ChatDocumentTab[] = [
  "report",
  "notes",
  "chat",
  "summary",
];

export const useTabOrder = () => {
  const { organizationId } = useParams<{ organizationId: string }>();
  const [tabOrder, setTabOrder] =
    useState<ChatDocumentTab[]>(DEFAULT_TAB_ORDER);

  const getStorageKey = useCallback(() => {
    return `sky.tabOrder.${organizationId}`;
  }, [organizationId]);

  const loadTabOrder = useCallback(() => {
    try {
      const stored = localStorage.getItem(getStorageKey());
      if (stored) {
        const parsed = JSON.parse(stored) as ChatDocumentTab[];
        if (
          parsed.length === DEFAULT_TAB_ORDER.length &&
          DEFAULT_TAB_ORDER.every((tab) => parsed.includes(tab))
        ) {
          setTabOrder(parsed);
          return;
        }
      }
    } catch (error) {}
    setTabOrder(DEFAULT_TAB_ORDER);
  }, [getStorageKey]);

  const saveTabOrder = useCallback(
    (newOrder: ChatDocumentTab[]) => {
      try {
        localStorage.setItem(getStorageKey(), JSON.stringify(newOrder));
        setTabOrder(newOrder);
      } catch (error) {}
    },
    [getStorageKey]
  );

  useEffect(() => {
    loadTabOrder();
  }, [loadTabOrder]);

  return {
    tabOrder,
    saveTabOrder,
  };
};
